<template>
  <div>
    <div class="playerbg"></div>
    <div class="width-css">
      <div class="img-css"><img :src="detail.image"/></div>
      <span class="player-name">{{ detail.name }}</span>
      <div class="num-css">
        <span>{{ detail.unitName }}</span>
        <span style="margin-left:50px;">积分 {{ detail.score }}</span>
        <span style="margin-left:50px;font-size:16px;">项目排名 <b>{{ rank }}</b></span>
      </div>
      <a-progress class="match-num" type="circle" :percent="detail.winNum" :width="80" :strokeWidth="8" strokeColor="#244e8f">
        <template #format="percent">
          <span style="color:black;">场次<br/>
            {{ percent }}
          </span>
        </template>
      </a-progress>
      <a-progress class="record-num" type="circle" :percent="(detail.winNum / (detail.winNum + detail.lostNum)) * 100" :width="80" :strokeWidth="8" strokeColor="#244e8f">
        <template #format="percent">
          <span style="color:black;font-size:13px;">战绩<br/>
            {{ detail.winNum }}胜/{{ detail.lostNum }}负
            <span style="display: none;">{{ percent }}</span>
          </span>
        </template>
      </a-progress>
      <a-progress class="win-num" type="circle" :percent="(detail.winNum / (detail.winNum + detail.lostNum)) * 100" :width="80" :strokeWidth="8" strokeColor="#244e8f">
        <template #format="percent">
          <span style="color:black;">胜率<br/>
            {{ parseInt(percent) }} %
          </span>
        </template>
      </a-progress>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      programId: this.$route.query.programId,
      rank: this.$route.query.rank,
      detail: {}
    }
  },
  created () {
    window.scrollTo(0, 0)
    this.detail = JSON.parse(decodeURI(this.$route.query.detail))
  },
  methods: {
  }
}
</script>
<style lang="scss" scoped>
.playerbg{
  height: 120px;
  padding-top: 40px;
  background-image: url('../../../../assets/weapon/playertopbg.png');

}
.width-css{
  width: 1200px;
  margin: 0 auto;
  height: 120px;
  position: relative;
  border-bottom: 5px solid rgb(238, 236, 236);
}
.img-css{
  position:absolute;
  top: -70px;
  width: 140px;
  height: 170px;
  border-radius:5px;
  background: white;
}
.width-css img{
  width: 110px;
  height: 140px;
  margin-left: 15px;
  margin-top: 15px;
}
.player-name{
  position:absolute;
  top: -70px;
  left: 150px;
  font-size: 25px;
  color:white;
}
.num-css{
  position:absolute;
  top: -30px;
  left: 150px;
  font-size: 14px;
  color:white;
}
.match-num{
  position:absolute;
  top: 20px;
  left: 170px;
  font-size: 14px;
  color:white;
}
.record-num{
  position:absolute;
  top: 20px;
  left: 330px;
  font-size: 14px;
  color:white;
}
.win-num{
  position:absolute;
  top: 20px;
  left: 490px;
  font-size: 14px;
  color:white;
}
</style>



// WEBPACK FOOTER //
// src/daoba-match/views/program/components/module/SkillHead.vue